const baseFields = require('./baseGameFields')

const fields = [
  {
    title: 'Cluster Support',
    name: 'clusterSupport',
    type: 'object',
    fields: [
      {
        title: 'Available',
        name: 'available',
        type: 'boolean',
      },
      {
        title: 'Price',
        name: 'price',
        type: 'number',
        description:
          "If cluster support costs extra. how much? If it's free set to zero.",
      },
    ],
  },
  {
    title: 'Procedural Map Generation (PGARK)',
    name: 'proceduralMaps',
    type: 'object',
    fields: [
      {
        title: 'Available',
        name: 'available',
        type: 'boolean',
      },
      {
        title: 'Price',
        name: 'price',
        type: 'number',
        description:
          "If procedural maps cost extra, specify the price in USD here. If it's free, it should be zero",
      },
    ],
  },
]

module.exports = {
  sanityTypeDef: {
    title: 'ARK: Survival Evolved',
    name: 'ark',
    type: 'object',
    fields: [...baseFields, ...fields],
    preview: {
      select: {},
      prepare() {
        return { title: 'ARK: Survival Evolved' }
      },
    },
  },
  fields,
}



// WEBPACK FOOTER //
// /opt/build/repo/sanity/schemas/games/arkInfo.js